import { BASE_URL } from '../../constants/defaultValues'
import Dictionary from '../dictionary'
import axios from 'axios'

const { InventoryAudit } = Dictionary

const InventoryAuditService = {
    barcodeSearchApi: async (paramsObj: {}) => {
        return axios.get(BASE_URL + InventoryAudit.barcodeSearch(), { params: paramsObj })
    },
    updateItemCondition: async (id:string, payload:{}) => {
        return axios.put(BASE_URL + InventoryAudit.itemCondition(id), payload )
    },
}
export default InventoryAuditService